import Link from 'next/link';
import type { ConditionParam } from '~/types/condition-param';

interface SalaryLinkProps {
  conditionParam: ConditionParam[];
}

export function SalaryLink(props: SalaryLinkProps) {
  const getConditionByType = (type: string) =>
    props.conditionParam.find((param) => param.type === type);

  const prefecture = getConditionByType('prefecture');
  const license = getConditionByType('license');
  const category = getConditionByType('category');

  const hasOtherConditions = props.conditionParam.some(
    (param) => !['prefecture', 'license', 'category'].includes(param.type),
  );

  if (hasOtherConditions) {
    return null;
  }

  if (prefecture && license && !category) {
    return (
      <div className="u-mt8 u-flex">
        <Link
          href={`/salaries/salary_licenses/${license.id}/salary_prefectures/${prefecture.id}/`}
          className="u-ml-auto u-fs14 u-lh18 u-inline-flex u-color-blue-light c-icon -right -arrow-right u-ml-auto"
          prefetch={false}
        >
          {`${prefecture.name}の${license.name}の年収情報を詳しく見る`}
        </Link>
      </div>
    );
  } else if (prefecture && !license && category) {
    return (
      <div className="u-mt8 u-flex">
        <Link
          href={`/salaries/salary_categories/${category.id}/salary_prefectures/${prefecture.id}/`}
          className="u-ml-auto u-fs14 u-lh18 u-inline-flex u-color-blue-light c-icon -right -arrow-right u-ml-auto"
          prefetch={false}
        >
          {`${prefecture.name}の${category.name}の年収情報を詳しく見る`}
        </Link>
      </div>
    );
  } else if (!prefecture && !license && category) {
    return (
      <Link
        href={`/salaries/salary_categories/${category.id}`}
        className="u-mt8 u-fs14 u-lh18 u-inline-flex u-color-blue-light c-icon -right -arrow-right u-ml-auto"
        prefetch={false}
      >
        {`${category.name}の年収情報を詳しく見る`}
      </Link>
    );
  } else if (!prefecture && license && !category) {
    return (
      <Link
        href={`/salaries/salary_licenses/${license.id}`}
        className="u-mt8 u-fs14 u-lh18 u-inline-flex u-color-blue-light c-icon -right -arrow-right u-ml-auto"
        prefetch={false}
      >
        {`${license.name}の年収情報を詳しく見る`}
      </Link>
    );
  } else if (prefecture && !license && !category) {
    return (
      <Link
        href={`/salaries/salary_prefectures/${prefecture.id}`}
        className="u-mt8 u-fs14 u-lh18 u-inline-flex u-color-blue-light c-icon -right -arrow-right u-ml-auto"
        prefetch={false}
      >
        {`${prefecture.name}の年収情報を詳しく見る`}
      </Link>
    );
  }

  return null;
}
